import { useCallback } from 'react';
import { useModulesQuery } from '@src/api/api-hooks/common/useModulesQuery.ts';

export const useModules = () => {
  const { data: modules } = useModulesQuery();
  const moduleByCode = useCallback(
    (code?: string) => modules.find((mod) => mod.code === code),
    [modules]
  );
  const moduleById = useCallback((id: number) => modules.find((mod) => mod.id === id), [modules]);

  const moduleByType = useCallback(
    (moduleType: string) => {
      return modules.find((mod) => mod.module_type === moduleType);
    },
    [modules]
  );

  return {
    modules,
    moduleByCode,
    moduleByType,
    moduleById,
  };
};
